var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { OnDestroy, OnInit } from '@angular/core';
import { GridsterComponent } from 'angular-gridster2';
import 'rxjs/add/observable/timer';
import * as moment from 'moment';
import { dashboardOptions, dynamicComponents } from './dashboard.config';
import { DashboardInboundWidgets, getWidget, inboundDashboard } from './dashboard.layout';
import { DashboardService } from './dashboard.service';
import { DashboardType } from './dashboard.type';
var DashboardComponent = /** @class */ (function () {
    function DashboardComponent(dashboardService) {
        this.dashboardService = dashboardService;
        this.options = dashboardOptions;
        this.dashboard = inboundDashboard;
        this.dynamicComponents = dynamicComponents;
        this.average = function (array, prop) { return array.reduce(function (sum, value) { return sum + (value[prop] || 0); }, 0) / array.length; };
    }
    DashboardComponent.prototype.ngOnInit = function () {
        // TODO: check a better way to determine gridster is ready to draw e.g. a chart to avoid glitches
        // timeout is matched to the transition delay length to be a little bit less
        var _this = this;
        this.updateInboundLists();
        this.dashboardRefreshInterval = setInterval(function () {
            _this.updateInboundLists();
        }, 3000);
        this.updateInboundStats();
        this.dashboardStatsRefreshInterval = setInterval(function () {
            _this.updateInboundStats();
        }, 60000);
    };
    DashboardComponent.prototype.ngOnDestroy = function () {
        clearInterval(this.dashboardRefreshInterval);
        clearInterval(this.dashboardStatsRefreshInterval);
    };
    DashboardComponent.prototype.updateInboundLists = function () {
        var _this = this;
        this.dashboardService.getInboundQueue().subscribe(function (callQueue) {
            _this.updateWidgetValue(DashboardInboundWidgets.call_queue, callQueue);
        });
        this.dashboardService.getWorkingUsersInbound().subscribe(function (inboundUsers) {
            _this.updateWidgetValue(DashboardInboundWidgets.users, inboundUsers);
        });
    };
    DashboardComponent.prototype.updateInboundStats = function () {
        var _this = this;
        this.dashboardService.getCallVolume(DashboardType.INBOUND).subscribe(function (results) {
            _this.updateWidgetValue(DashboardInboundWidgets.inbound_calls, {
                labelAll: 'INBOUND_DASHBOARD.INBOUND_CALLS',
                labelAnswered: 'INBOUND_DASHBOARD.ANSWERED_CALLS',
                data: {
                    all: results.inbound_graph
                        .map(function (stat) { return ({
                        count: stat.allCalls,
                        date: stat.date
                    }); })
                        .sort(function (a, b) { return moment(a.date).diff(moment(b.date)); })
                        .map(function (stat) { return (__assign({}, stat, { date: moment(stat.date).format() })); }),
                    answered: results.inbound_graph
                        .map(function (stat) { return ({
                        count: stat.answeredCalls,
                        date: stat.date
                    }); })
                        .sort(function (a, b) { return moment(a.date).diff(moment(b.date)); })
                        .map(function (stat) { return (__assign({}, stat, { date: moment(stat.date).format() })); }),
                    total: {
                        calls: results.inbound_total.calls,
                        duration: results.inbound_total.duration,
                        answeredCalls: results.inbound_total.answeredCalls
                    },
                    numbers: results.inbound_numbers.map(function (stat) { return ({
                        label: stat.label,
                        msisdn: stat.msisdn,
                        isoCountry: stat.isoCountry,
                        allCalls: stat.allCalls,
                        answeredCalls: stat.answeredCalls,
                        callsDuration: stat.callsDuration
                    }); })
                }
            });
        });
        this.dashboardService.getCallVolume(DashboardType.OUTBOUND).subscribe(function (results) {
            _this.updateWidgetValue(DashboardInboundWidgets.outbound_calls, {
                labelAll: 'INBOUND_DASHBOARD.OUTBOUND_CALLS',
                labelAnswered: 'INBOUND_DASHBOARD.ANSWERED_CALLS',
                data: {
                    all: results.outbound_graph
                        .map(function (stat) { return ({
                        count: stat.allCalls,
                        date: stat.date
                    }); })
                        .sort(function (a, b) { return moment(a.date).diff(moment(b.date)); })
                        .map(function (stat) { return (__assign({}, stat, { date: moment(stat.date).format() })); }),
                    answered: results.outbound_graph
                        .map(function (stat) { return ({
                        count: stat.answeredCalls,
                        date: stat.date
                    }); })
                        .sort(function (a, b) { return moment(a.date).diff(moment(b.date)); })
                        .map(function (stat) { return (__assign({}, stat, { date: moment(stat.date).format() })); }),
                    total: {
                        calls: results.outbound_total.calls,
                        duration: results.outbound_total.duration,
                        answeredCalls: results.outbound_total.answeredCalls
                    },
                    agents: results.outbound_agents.map(function (stat) { return ({
                        agent: stat.agent,
                        allCalls: stat.allCalls,
                        answeredCalls: stat.answeredCalls,
                        callsDuration: stat.callsDuration
                    }); })
                }
            });
        });
        this.dashboardService.getInboundStats().subscribe(function (res) {
            _this.updateWidgetValue(DashboardInboundWidgets.abandonment_rate, {
                value: (_this.average(res, 'callsToday') - _this.average(res, 'callsAnsweredToday')) /
                    _this.average(res, 'callsToday') *
                    100,
                valueYesterday: (_this.average(res, 'callsYesterday') - _this.average(res, 'callsAnsweredYesterday')) /
                    _this.average(res, 'callsYesterday') *
                    100
            });
            _this.updateWidgetValue(DashboardInboundWidgets.sla, {
                value: _this.average(res, 'serviceLevelToday'),
                valueYesterday: _this.average(res, 'serviceLevelYesterday')
            });
        });
    };
    DashboardComponent.prototype.updateWidgetValue = function (dashboardWidget, value) {
        var widget = getWidget(this.dashboard, dashboardWidget);
        var inputs = widget && widget.inputs;
        if (inputs) {
            inputs.results.next(value);
        }
    };
    DashboardComponent.prototype.changeSizeWidget = function (widget, size) {
        getWidget(this.dashboard, widget).rows = size;
        this.options.api.optionsChanged();
    };
    return DashboardComponent;
}());
export { DashboardComponent };
